import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import tokens from '@verifime/design-tokens';
import { DvsErrors } from './DvsErrors';
import { TDvsErrorDetail } from './types';

export const DvsErrorTooltip = ({
  errorDetails,
}: Readonly<{ errorDetails: TDvsErrorDetail[] }>) => {
  if (!errorDetails || errorDetails.length < 1) {
    return null;
  }

  const detailNodes = errorDetails.map((detail, index) => {
    return (
      <Stack key={`dvs-error-${index}`} gap={tokens.spacingXs}>
        <Stack direction="row" gap={tokens.spacingXs}>
          <Typography variant="caption">Field:</Typography>
          <Typography variant="body2">{detail.field}</Typography>
        </Stack>
        <Stack direction="row" gap={tokens.spacingXs}>
          <Typography variant="caption">Source:</Typography>
          <Typography variant="body2">{detail.source}</Typography>
        </Stack>
        <Typography variant="body1">{detail.message}</Typography>
      </Stack>
    );
  });

  return (
    <Tooltip
      title={
        <Box padding={tokens.spacing2xs}>
          <DvsErrors detailNodes={detailNodes} />
        </Box>
      }
      placement="right"
      color="error"
    >
      <WarningAmberIcon />
    </Tooltip>
  );
};
